import { useNavigate } from '@ywwwtseng/react-kit';
import { Typography } from '@ywwwtseng/tma-react-kit';
import { TokenIcon } from './TokenIcon';
import type { UnifiedToken } from '@/types';
import { useTokenPrice } from '@/hooks/useTokenPrice';
import { useUnifiedUserBalance } from '@/hooks/useUnifiedUserBalance';
import { displayAmount } from '@/utils/token';

interface UnifiedTokenBalanceProps {
  token: UnifiedToken;
}

export function UnifiedTokenBalance({ token }: UnifiedTokenBalanceProps) {
  const navigate = useNavigate();
  const { formatted } = useTokenPrice(token.id);
  const balance = useUnifiedUserBalance(token);

  return (
    <div
      key={token.id}
      className="h-stack w-full gap-2 px-1 py-1.5 cursor-pointer"
      onClick={() => {
        navigate('Token', { params: { token_id: token.id } });
      }}
    >
      <TokenIcon token={token} width={32} height={32} />
      <div className="v-stack w-full !items-start">
        <Typography size="3" weight={500}>
          {token.symbol}
        </Typography>
        {formatted && (
          <Typography size="1" color="#777777">
            ${formatted}
          </Typography>
        )}
      </div>
      <div className="v-stack w-full ml-auto !items-end">
        <Typography size="3" weight={500}>
          {displayAmount(balance.formatted)}
        </Typography>
        {balance.price && (
          <Typography size="1" color="#777777">
            {`$${balance.price}`}
          </Typography>
        )}
      </div>
    </div>
  );
}
